__turbopack_context__.v({
  "footerContainer": "Footer-module-scss-module__kqmR4W__footerContainer",
  "footerContainer__landing": "Footer-module-scss-module__kqmR4W__footerContainer__landing",
  "footerHr": "Footer-module-scss-module__kqmR4W__footerHr",
  "footerLeft": "Footer-module-scss-module__kqmR4W__footerLeft",
  "footerLogo": "Footer-module-scss-module__kqmR4W__footerLogo",
  "footerNavItem": "Footer-module-scss-module__kqmR4W__footerNavItem",
  "footerNavMenu": "Footer-module-scss-module__kqmR4W__footerNavMenu",
  "footerNavMenu__box": "Footer-module-scss-module__kqmR4W__footerNavMenu__box",
  "footerRight": "Footer-module-scss-module__kqmR4W__footerRight",
  "footerSecondSub": "Footer-module-scss-module__kqmR4W__footerSecondSub",
  "footerSubText": "Footer-module-scss-module__kqmR4W__footerSubText",
  "footerSubTextLink": "Footer-module-scss-module__kqmR4W__footerSubTextLink",
  "footerSubTextLink__notline": "Footer-module-scss-module__kqmR4W__footerSubTextLink__notline",
  "footerSubTextPreLink": "Footer-module-scss-module__kqmR4W__footerSubTextPreLink",
  "footerSubText__left": "Footer-module-scss-module__kqmR4W__footerSubText__left",
  "footerSubText__link": "Footer-module-scss-module__kqmR4W__footerSubText__link",
  "footerSubText__links": "Footer-module-scss-module__kqmR4W__footerSubText__links",
  "footerSubText__right": "Footer-module-scss-module__kqmR4W__footerSubText__right",
  "footerWhite__button": "Footer-module-scss-module__kqmR4W__footerWhite__button",
  "footerWrapper": "Footer-module-scss-module__kqmR4W__footerWrapper",
  "formaLogo": "Footer-module-scss-module__kqmR4W__formaLogo",
  "formaLogoBox": "Footer-module-scss-module__kqmR4W__formaLogoBox",
  "svgClass": "Footer-module-scss-module__kqmR4W__svgClass",
});
